const { getElements } = window.BAO.Utils

export class ProductCompare extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['link', 'column']
  }

  constructor () {
    super()

    this.isTicking = false

    this.handleIntersection = this.handleIntersection.bind(this)
    this.observer = new IntersectionObserver(this.handleIntersection)
  }

  setupListeners () {
    super.setupListeners()

    this.els.link.elements.forEach(link => {
      this.listeners.add(link, 'mouseover', event =>
        this.setActiveLink(event.currentTarget),
      )

      this.listeners.add(link, 'focus', event =>
        this.setActiveLink(event.currentTarget),
      )
    })

    this.observableRegions.forEach(region => {
      this.observer.observe(region)
    })
  }

  /** @param {IntersectionObserverEntry[]} entries */
  handleIntersection (entries) {
    const firstVisibleRegion = entries.find(entry => entry.isIntersecting)
    if (!firstVisibleRegion) {
      return
    }

    const { id } = firstVisibleRegion.target
    const relatedLink = this.els.link.elements.find(
      link => link.hash === `#${id}`,
    )
    this.setActiveLink(relatedLink)
  }

  /** @param {HTMLAnchorElement} link */
  setActiveLink (link) {
    this.els.link.elements.forEach(element => {
      element.classList.toggle(this.dataset.activeClass, link === element)
    })
  }

  /** @returns {HTMLElement[]} */
  get observableRegions () {
    const selector = this.els.column.selector
    return getElements(selector, { context: this })
  }
}

if (!customElements.get('product-compare')) {
  customElements.define('product-compare', ProductCompare)
}

export class ProductCompareSwatch extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.els.swatch.elements.forEach(swatch => {
      this.listeners.add(swatch, 'click', () => this.selectSwatch(swatch))
    })
  }

  /** @param {HTMLButtonElement} swatch */
  selectSwatch (swatch) {
    if (swatch.classList.contains(this.activeClass)) return

    this.els.swatch.elements.forEach(element => {
      element.classList.toggle(this.activeClass, element === swatch)
    })

    const {
      productId,
      variantId,
      available,
      price,
      worth,
      viewUrl,
    } = swatch.dataset
    const isAvailable = available === 'true'

    if (this.els.price.exists) {
      this.els.price.element.textContent = price
    }

    if (this.els.worth.exists) {
      this.els.worth.element.textContent = worth
      this.els.worth.element.hidden = !worth
    }

    if (this.els.variantInput.exists) {
      this.els.variantInput.element.value = variantId
    }

    if (this.els.productInput.exists) {
      this.els.productInput.element.value = productId
    }

    if (this.els.addButton.exists) {
      this.els.addButton.element.disabled = !isAvailable
    }

    if (this.els.addButtonText.exists) {
      this.els.addButtonText.element.textContent = isAvailable
        ? this.dataset.addText
        : this.dataset.soldOutText
    }

    if (this.els.viewLink.exists) {
      this.els.viewLink.element.href = viewUrl
    }

    if (this.els.media.exists) {
      const template = swatch.parentElement.querySelector('template')

      if (template) {
        this.els.media.element.swapSlides(template.innerHTML)
      }
    }
  }

  get activeClass () {
    return this.dataset.activeClass
  }
}

if (!customElements.get('product-compare-swatch')) {
  customElements.define('product-compare-swatch', ProductCompareSwatch)
}
